// @flow

import BaseEventEmitter from "./Base";

class NodeEventEmitter extends BaseEventEmitter {}

export default NodeEventEmitter;



// WEBPACK FOOTER //
// ./node_modules/@tvg/mediator/src/EventEmitters/Node.js